import * as React from 'react';
import SVGIcon from '../SVGIcon';

const GridDisplayTypeChoice: React.FC = () => {
  return (
    <SVGIcon width="107" height="56" viewBox="0 0 107 56" fill="none">
      <>
        <g clipPath="url(#clip0_6093_2945)">
          <g clipPath="url(#clip1_6093_2945)">
            <rect y="-0.47644" width="33.3753" height="27.2583" rx="0.536581" fill="#DDDDDD" />
            <path
              d="M0 0.0601407C0 -0.236205 0.240235 -0.47644 0.536581 -0.47644H32.8388C33.1351 -0.47644 33.3753 -0.236205 33.3753 0.0601406V9.53137H0V0.0601407Z"
              fill="#9A9A9A"
            />
            <path d="M22.0205 20.4767H31.3363V25.1686H22.0205V20.4767Z" fill="#9A9A9A" />
          </g>
          <g clipPath="url(#clip2_6093_2945)">
            <rect
              x="37"
              y="-0.47644"
              width="33.3753"
              height="27.2583"
              rx="0.536581"
              fill="#DDDDDD"
            />
            <path
              d="M37 0.0601407C37 -0.236205 37.2402 -0.47644 37.5366 -0.47644H69.8388C70.1351 -0.47644 70.3753 -0.236205 70.3753 0.0601406V9.53137H37V0.0601407Z"
              fill="#9A9A9A"
            />
            <path d="M59.0205 20.4767H68.3363V25.1686H59.0205V20.4767Z" fill="#9A9A9A" />
          </g>
          <g clipPath="url(#clip3_6093_2945)">
            <rect
              x="73"
              y="-0.47644"
              width="33.3753"
              height="27.2583"
              rx="0.536581"
              fill="#DDDDDD"
            />
            <path
              d="M73 0.0601407C73 -0.236205 73.2402 -0.47644 73.5366 -0.47644H105.839C106.135 -0.47644 106.375 -0.236205 106.375 0.0601406V9.53137H73V0.0601407Z"
              fill="#9A9A9A"
            />
            <path d="M95.0205 20.4767H104.336V25.1686H95.0205V20.4767Z" fill="#9A9A9A" />
          </g>
          <g clipPath="url(#clip4_6093_2945)">
            <rect y="30.7819" width="33.3753" height="27.2583" rx="0.536581" fill="#DDDDDD" />
            <path
              d="M0 31.3184C0 31.0221 0.240235 30.7819 0.536581 30.7819H32.8388C33.1351 30.7819 33.3753 31.0221 33.3753 31.3184V40.7897H0V31.3184Z"
              fill="#9A9A9A"
            />
            <path d="M22.0205 51.735H31.3363V56.4269H22.0205V51.735Z" fill="#9A9A9A" />
          </g>
          <g clipPath="url(#clip5_6093_2945)">
            <rect
              x="37"
              y="30.7819"
              width="33.3753"
              height="27.2583"
              rx="0.536581"
              fill="#DDDDDD"
            />
            <path
              d="M37 31.3184C37 31.0221 37.2402 30.7819 37.5366 30.7819H69.8388C70.1351 30.7819 70.3753 31.0221 70.3753 31.3184V40.7897H37V31.3184Z"
              fill="#9A9A9A"
            />
            <path d="M59.0205 51.735H68.3363V56.4269H59.0205V51.735Z" fill="#9A9A9A" />
          </g>
          <g clipPath="url(#clip6_6093_2945)">
            <rect
              x="73"
              y="30.7819"
              width="33.3753"
              height="27.2583"
              rx="0.536581"
              fill="#DDDDDD"
            />
            <path
              d="M73 31.3184C73 31.0221 73.2402 30.7819 73.5366 30.7819H105.839C106.135 30.7819 106.375 31.0221 106.375 31.3184V40.7897H73V31.3184Z"
              fill="#9A9A9A"
            />
            <path d="M95.0205 51.735H104.336V56.4269H95.0205V51.735Z" fill="#9A9A9A" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_6093_2945">
            <rect width="106.375" height="56" fill="white" />
          </clipPath>
          <clipPath id="clip1_6093_2945">
            <rect y="0.00012207" width="33.3753" height="27.2583" rx="1.66877" fill="white" />
          </clipPath>
          <clipPath id="clip2_6093_2945">
            <rect
              x="37"
              y="0.00012207"
              width="33.3753"
              height="27.2583"
              rx="1.66877"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip3_6093_2945">
            <rect
              x="73"
              y="0.00012207"
              width="33.3753"
              height="27.2583"
              rx="1.66877"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip4_6093_2945">
            <rect y="31.2584" width="33.3753" height="27.2583" rx="1.66877" fill="white" />
          </clipPath>
          <clipPath id="clip5_6093_2945">
            <rect x="37" y="31.2584" width="33.3753" height="27.2583" rx="1.66877" fill="white" />
          </clipPath>
          <clipPath id="clip6_6093_2945">
            <rect x="73" y="31.2584" width="33.3753" height="27.2583" rx="1.66877" fill="white" />
          </clipPath>
        </defs>
      </>
    </SVGIcon>
  );
};

export default GridDisplayTypeChoice;
